<template lang="pug">
  router-link.lei-link(:class="{'active': !challengeMode}" :to="to") {{lei}}
</template>
<script>
import Challenge from '@/mixins/challenge'

export default {
  mixins: [ Challenge, ],
  props: {
    lei: {
      type: String,
      required: true,
    },
  },
  data () {
    return {}
  },
  computed: {
    to () {
      return !this.challengeMode ? {
        name: 'RecordDetailsPage',
        params: { id: this.lei, },
      } : ''
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"
  .lei-link
    border-bottom 1px solid $info-color
    transition all .2s ease
    &.active:hover
        color $primary-color
        cursor pointer
        border-bottom 1px solid $primary-color

</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/LeiCodeLink.vue